import { paginationCalculator } from "pagination-calculator";
import React, { useEffect, useState } from "react";
import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import {
  CreateStarForFavoriteFalse,
  CreateStarForFavoriteTrue,
} from "../Candidates/Search/CandidateSearchView/FavoriteStar";
import DataGrid from "../common/DataGrid";
import Header from "../common/Header";
import Loader from "../common/Loader";
import Sidebar from "../common/Sidebar";
import { resetJobOpportunityInfo, setJobId } from "../JobOpportunity/action";
import { updateJobId } from "../JobOpportunity/Summary/action";
import {
  deleteJob,
  editPost,
  firstPage,
  gotoPage,
  lastPage,
  loadMultiShiftJobInfo,
  nextPage,
  previousPage,
  setPageSize,
  UnclaimedbyEmployerApi,
  updateSort,
  editSaveTimeOccurrence,
  DeleteMultiShiftJobOccurence,
  getUnClaimEmployerReasons,
  getDeleteEmployerReasons,
  resetMatchingCandidateInfo,
  deleteAllMultishiftOccurrence,
  multishiftJoinFilterData,
} from "./action";
import { shiftsCoverageSelector } from "./selector";
import "./index.css";
import StarsRenderer from "../common/DataGrid/starsRenderer";
import Modal from "../common/Modal/modal";
import { convertToString } from "../JobOpportunity/recurrenceConvertToString/recurrenceConvertToString";
import GPSInfo from "./GPSInfo";
import Unclaimedmodalpopup from "./Unclaimedmodalpopup";
import ViewJob from "../ViewJob";
import { resetModifyOccurrence, updateRequest, upda } from "../ViewJob/action";
import ModalGoTo from "./ModalGoTo";
import { viewJobSelector } from '../ViewJob/selector'
import { BiMessageEdit } from 'react-icons/bi'
import BackFixedButton from "../common/BackFixedButton/BackFixedButton";
import Spinner from "../common/Spinner/spinner";
import { toast } from "react-toastify";
import { refreshMultishiftInfo } from "./slice";
import { payRateTypeObj } from "../../helpers/data";
import { setIsErrorPaymentRate } from "../ViewJob/slice";
import Mentor from "../assets/svg/Mentor";

const MultiShiftJobInfo = () => {
  const navigate = useNavigate();
  const [openGps, setOpenGps] = useState({
    show: false,
    jobData: undefined,
  });
  const [openMessaging, setOpenMessaging] = useState({
    open: false,
    jobId: undefined,
  });
  const [deletedata, setdeletedata] = useState({
    show: false,
    jobId: undefined,
  });
  const [Unclaimdata, setUnclaimData] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const empId = login.employerUniqueId;
  const AppuseridValue = login.appUserId;
  const url = config.baseUrl;
  const { data, pageSize, page, gridloader, matchingCandidateinfo, loadingFlag, unClaimEmployerReasons, deleteEmployerReasons, updatedShiftTime, multiShiftFilterData } = useSelector(
    shiftsCoverageSelector
  );
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [UnclaimId, setUnclaimId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showUnclaim, setShowUnclaim] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showJobMessageModal, setShowJobMessageModal] = useState(false);
  const [showViewJob, setShowViewJob] = useState(false);
  const [showMultiDelete, setShowMultiDelete] = useState(false)
  const { multiShiftId, acceptableTravelDistance, candidateUniqueId, jobsShiftUniqueId, pageName,viewJobTitle } =
    location.state || "";
  const [jobSummary, setJobSummary] = useState(null)

  const { requestData, jobInfo, shift } = useSelector(viewJobSelector);
  const jobsShiftsDepartmentsList = useSelector(store => store.viewJobDetails.jobsShiftsDepartmentsList);
  const payRateTotalShiftAmount = useSelector(store => store.viewJobDetails.payRateTotalShiftAmount);
  const payRateType = useSelector(store => store.viewJobDetails.payRateType);
  const [mulJobdetail, setmulJobdetail] = useState({ JobUniqueId: '', jobClaimId: '', occurranceDate: '' });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [shiftDate, setShiftDate] = useState('')
  // Confirmation Modal Box Dropdown Form initial data
  const [ModalFormData, setModalFormData] = useState({
    reason: "",
    comments: "",
  });

  // Confirmation Modal Box Dropdown Form Error initial data
  const [ErrorsModalFormData, setErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });

  // Confirmation Modal Box Dropdown Form HandleChange Function
  const ConfirmationModalBoxHandleChange = (e) => {
    setModalFormData({
      ...ModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  // Delete Confirmation Modal Box Dropdown Form initial data
  const [DeleteModalFormData, setDeleteModalFormData] = useState({
    reason: "",
    comments: "",
  });

  // Delete Confirmation Modal Box Dropdown Form Error initial data
  const [DeleteErrorsModalFormData, setDeleteErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });

  // Delete Confirmation Modal Box Dropdown Form HandleChange Function
  const DeleteConfirmationModalBoxHandleChange = (e) => {
    setDeleteModalFormData({
      ...DeleteModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  // Multishift filter data initial state
  const [multiShiftFilterUpdateId, setMultiShiftFilterDataUpdateId] = useState(null);

  // Remove page name and Id 
  const pageNameToRemove = {
    "awaitingShifts": [5, 2, 3],
    "openshifts": [4, 5],
    "completedShifts": [4, 5],
    "awaitingpayments": [2, 3, 4],
    "shiftscoverage": [null]
  };

  // remove id
  const idToRemove = pageNameToRemove[pageName];

  // Current display options
  const updatedDisplayOptions = multiShiftFilterData.filter(option => !idToRemove?.includes(option.id));

  // Final MultishiftFilter data
  const finalMultiShiftFilterData = pageName === "awaitingShifts" || pageName === "awaitingpayments" ? updatedDisplayOptions.reverse() : updatedDisplayOptions

  // While change the page that time filter data has been changed
  useEffect(() => {
    if (pageName === "openshifts" || pageName === "completedShifts" || pageName === "shiftscoverage") {
      setMultiShiftFilterDataUpdateId(1)
    } else if (pageName === "awaitingShifts") {
      setMultiShiftFilterDataUpdateId(4)
    } else if (pageName === "awaitingpayments") {
      setMultiShiftFilterDataUpdateId(5)
    }
  }, [pageName])

  // Main page API Call
  useEffect(() => {
    if (config.baseUrl) {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId,
          multishiftJobInfoFilter: parseInt(multiShiftFilterUpdateId),
        })
      );
      // Unclaim Reasons API Method
      dispatch(getUnClaimEmployerReasons(`${config.baseUrl}`));
      // Delete Reasons API Method
      dispatch(getDeleteEmployerReasons(`${config.baseUrl}`));
      // Multishift Join filter data
      dispatch(multishiftJoinFilterData(`${config.baseUrl}`));
    }
  }, [config.baseUrl, multiShiftFilterUpdateId]);

  useEffect(() => {
    if (data?.jobInfo) {
      setJobSummary(data?.jobInfo)
    }
  }, [data])

  if (matchingCandidateinfo?.jobShiftUniqueId && matchingCandidateinfo?.navigateMatchingCandidate && matchingCandidateinfo?.editJobUniqueId) {
    navigate("/matchingcandidate",
      {
        state: {
          matchingJobid: matchingCandidateinfo?.jobShiftUniqueId,
          acceptableTravelDistance: matchingCandidateinfo?.acceptableTravelDistance,
          jobsClaimId: matchingCandidateinfo?.jobsClaimId,
          jobUniqueId: matchingCandidateinfo?.editJobUniqueId,
          NoOfShiftsneeded: false,
          hideEditJobShiftType:requestData?.shiftType
        }
      })
    dispatch(resetMatchingCandidateInfo())
  }

  const gotoFirstPage = () => {
    dispatch(firstPage()).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const gotoNextPage = () => {
    dispatch(nextPage()).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const gotoPreviousPage = () => {
    dispatch(previousPage()).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const gotoLastPage = () => {
    dispatch(lastPage()).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const gotoSelectedPage = (page) => {
    dispatch(gotoPage(page)).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const updatePageSize = (size) => {
    dispatch(setPageSize(size)).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
  };
  const refresh = () => {
    if (config.baseUrl) {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId,
          multishiftJobInfoFilter: parseInt(multiShiftFilterUpdateId),
        })
      ).then(() => {
        if (pageName === "openshifts" || pageName === "completedShifts" || pageName === "shiftscoverage") {
          setMultiShiftFilterDataUpdateId(1)
        } else if (pageName === "awaitingShifts") {
          setMultiShiftFilterDataUpdateId(4)
        } else if (pageName === "awaitingpayments") {
          setMultiShiftFilterDataUpdateId(5)
        }
      })
    }
  };

  const navigateMultiShift = () => {
    navigate("/multiShiftJobInfo", {
      state: {},
    });
  };

  const createStarforFavorite = (flag) => {
    const star = {
      size: 20,
      count: 1,
      value: flag ? 1 : 0,
      edit: false,
      color: flag ? "green" : "Grey",
      activeColor: flag ? "green" : "Grey",
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };
  const generateRowData = (data, headers) => {
    const rowData = {};
    headers.forEach((header) => {
      if (header.type === "text") {
        if (typeof header.field === "array") {
          rowData[header.name] = header.field.map((fld) => data[fld]).join(" ");
        } else {
          if (header.field === "serialNo") {
            rowData[header.name] = (
              <span>#
                <span style={{ fontWeight: "bold" }}>{data[header.field]}</span>
              </span>
            );
          }
          else {
            rowData[header.name] = data[header.field]
          }
          // rowData[header.name] = (
          //   <span style={{ color: data?.isPosted ? "" : "red" }}>
          //     {data[header.field]}
          //   </span>
          // );
        }
        const fistname = data["candidateFirstName"]
          ? data["candidateFirstName"]
          : "";
        const lastName = data["candidateLastName"]
          ? data["candidateLastName"]
          : "";
        const displayname = fistname + " " + lastName;

        if (header.field === "name") {
          // rowData[header.name] = (
          //   <span style={{ color: data?.isPosted ? "" : "red" }}>
          //     {displayname}
          //   </span>
          // );
          rowData[header.name] = displayname;
        }
        if (header.field === "isMentor") {
          const isMentor = data?.isMentor
          rowData[header.name] = displayname.length > 1 ? (
            <span><Mentor fillColor={isMentor ? "green": "white"} /></span>
          ) : null
        }
        if (header.field === "isFavorite") {
          rowData[header.name] =
            displayname.length > 1 ? (
              <span>{createStarforFavorite(data[header.field])}</span>
            ) : (
              ""
            );
        }
        // if (header.field === 'locationName') {
        //     rowData[header.name] = <span style={{ color: data?.isPosted ? '' : 'red' }}>{data[header.field]}</span>
        // }
        // isPosted
      } else {
        if (header.field === "isClaimed") {
          // const isClaimedtrure = data["isClaimed"];
          // const isUnClaimedtrure = data["isUnClaimed"];
          // const isCheckedOutTrue = data["isCheckedOut"]
          const showIcon = true; //gpsStatus !== 0 && gpsStatus !== 3;
          let iconClass = ''
          const claimColor = data["anchorColor"];
          iconClass = claimColor === 1 ? "red-icon" : claimColor === 2 ? "yellow-icon" : claimColor === 3 ? "green-icon" : ''

          // const iconClass =
          //   isClaimedtrure || isCheckedOutTrue === true
          //     ? "green-icon"
          //     : isUnClaimedtrure === true
          //       ? "yellow-icon"
          //       : "red-icon";

          if (showIcon) {
            rowData[header.name] = {
              type: "icon",
              class: `icon-align fa fa-anchor ${iconClass}`,
              rightSideText: <span className="bold-text ms-1" style={{color: '#337166'}}>{data?.isConfirmedShift ? 'C' : ''}</span>
            };
          }
        }
        if (header.field === "isUnClaimed") {
          const iconClassforclaimed = "orange-icon";
          const isClaimed = data["isClaimed"];
          const isCheckedIn = data["isCheckedIn"];
          const isUnClaimed = data["isUnClaimed"];
          if (isClaimed === true && isCheckedIn === false) {
            rowData[header.name] = [
              {
                type: "icon",
                class: `icon-align fa fa-remove ${iconClassforclaimed}`,
                onClick: () => {
                  showUnclaimdata(data["jobsClaimId"]);
                },
              },
            ];
            // } else if (isUnClaimed === true && !data['candidateUniqueId']) {
            // } else if ((jobSummary?.isClaimed === true && isClaimed === false) && !data['candidateUniqueId']) {
          } else if ((isClaimed === false) && !data['candidateUniqueId']) {
            rowData[header.name] = (<BiMessageEdit onClick={() => viewJobinSamePage(data["jobUniqueId"],
              data["currentMultiShiftJobDate"],
              data["jobsClaimId"],
              data["shiftStartTime"],
              data["shiftEndTime"],
              jobsShiftUniqueId,
              data["shiftType"],
              true,
              data['occurrenceCorrectionType'])} size={'1.5rem'} color={'#20851a'} style={{ cursor: 'pointer' }} />)
          }
        }
        // const showIcon = true;
        // const iconClassforclaimed = "orange-icon";
        // const isClaimedchk = data["isClaimed"];
        // const isCheckedInchk = data["isCheckedIn"];
        // if (isClaimedchk === true && isCheckedInchk === false) {
        //   if (showIcon) {
        //     rowData[header.name] = [
        //       {
        //         type: "icon",
        //         class: `icon-align fa fa-remove ${iconClassforclaimed}`,
        //         onClick: () => {
        //           showUnclaimdata(data["jobUniqueId"]);
        //         },
        //       },
        //     ];
        //   }
        // }
        // }
        if (header.field === "isCheckedIn") {
          const isCheckedIn = data[header.field];
          const iconClass = isCheckedIn
            ? "fa-sign-in green-icon"
            : "fa-sign-in red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass}`,
            blink: data?.notCheckedIn && data?.checkedInCountTime ? true : false,
            data: data?.checkedInCountTime
          };
        }
        if (header.field === "breakTimeFlash") {
          // const icon_color = data?.breakTimeFlash && data?.breakTimeCountTime ? 'green-icon' : 'grey-icon';

          // rowData[header.name] = {
          //   type: "icon",
          //   class: `fa icon-align fa-pause-circle-o ${icon_color}`,
          //   blink: data?.breakTimeFlash && data?.breakTimeCountTime ? true : false,
          //   data: data?.breakTimeCountTime
          // };

          const breakCountFlag = data?.breakTimeFlash;

          const icon_color = breakCountFlag === 0 ? 'grey-icon' : breakCountFlag === 1 || breakCountFlag === 2 ? 'green-icon' : ''

          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align fa-pause-circle-o ${icon_color}`,
            blink: breakCountFlag === 2 ? true : false,
            data: data?.breakTimeCountTime,
            title: data?.brekTypes ? data?.brekTypes : ''
          };


        }
        if (header.field === "isCheckedOut") {
          const isCheckedOut = data[header.field];
          const iconClass = isCheckedOut
            ? "fa icon-align fa-sign-out fa-flip-horizontal green-icon"
            : "fa icon-align fa-sign-out fa-flip-horizontal red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass} me-auto`,
            blink: data?.notCheckedOut && data?.checkedOutCountTime ? true : false,
            data: data?.checkedOutCountTime
          };
        }
        if (header.field === "isPaid") {
          const isPaid = data[header.field];
          const iconClass = isPaid
            ? "green-icon fa-check-circle"
            : "fa-times-circle red-icon";
          rowData[header.name] = {
            type: "icon",
            class: `fa icon-align ${iconClass}`,
          };
        }
        // if (header.field === "edit") {
        //   rowData[header.name] = {
        //     type: "icon",
        //     class: `fa fa-pencil icon-align`,
        //     onClick: () => {
        //       editJob(data["jobUniqueId"], data["isClaimed"]);
        //     },
        //   };
        // }

        if (header.field === "view") {
          rowData[header.name] = {
            type: "icon",
            class: `icon-align fa fa-file`,
            onClick: () => {
              // viewJob(
              //   data["jobUniqueId"],
              //   data["acceptableTravelDistance"],
              //   data["currentMultiShiftJobDate"],
              //   data["jobsClaimId"]
              // );
              viewJobinSamePage(data["jobUniqueId"],
                data["currentMultiShiftJobDate"],
                data["jobsClaimId"],
                data["shiftStartTime"],
                data["shiftEndTime"],
                data["jobsShiftUniqueId"],
                data["shiftType"],
                false,
                data['occurrenceCorrectionType'])
            },
          };
        }
        // if (header.field === "delete") {
        //   rowData[header.name] = {
        //     type: "icon",
        //     class: `icon-align fe fe-trash-2 fa-lg`,
        //     onClick: () => {
        //       showDeletedata(data["jobUniqueId"]);
        //     },
        //   };
        // }
        // if (header.field === 'message') {
        //     rowData[header.name] = {
        //         type: 'icon',
        //         class: `icon-align fa fa-commenting`,
        //         onClick: () => {
        //             viewJobMessages(data['jobShiftUniqueId'])
        //         }

        //     }
        // }
        if (header.name === "Multi Shift") {
          rowData[header.name] = [
            {
              type: "icon",
              class: `fa fa-pencil icon-align`,
              onClick: () => {
                navigateMultiShift();
              },
            },
          ];
        }
        if (header.name === "Action") {
          rowData[header.name] = [
            // {
            //   type: "icon",
            //   class: `icon-align fa fa-commenting`,

            //   onClick: () => {
            //     viewJobMessages(
            //       data["jobShiftUniqueId"],
            //       data["isClaimed"],
            //       data["candidateUniqueId"]
            //     );
            //   },
            // },
            {
              type: "icon",
              class: `icon-align fa fa-file green-color-icon`,
              onClick: () => {
                // viewJob(
                //   data["jobUniqueId"],
                //   data["acceptableTravelDistance"],
                //   data["currentMultiShiftJobDate"],
                //   data["jobsClaimId"]
                // );
                viewJobinSamePage(data["jobUniqueId"],
                  data["currentMultiShiftJobDate"],
                  data["jobsClaimId"],
                  data["shiftStartTime"],
                  data["shiftEndTime"],
                  data["jobsShiftUniqueId"],
                  data["shiftType"],
                   false,
                  data['occurrenceCorrectionType'])
              },
            },
            // {
            //   type: "icon",
            //   class: `fa fa-pencil icon-align`,
            //   onClick: () => {
            //     editJob(
            //       data["jobUniqueId"],
            //       data["isClaimed"],
            //       data["acceptableTravelDistance"]
            //     );
            //   },
            // },
            {
              type: "icon",
              class: `icon-align fe fe-trash-2 fa-lg green-color-icon`,
              onClick: () => {
                if (data?.isClaimed === true) {
                  toast.warning("This shift already claimed, Please unclaim before delete the shift")
                } else if (data?.isCheckedIn === true && data?.isCheckedOut !== true) {
                  toast.warning("Shift is in progress, cannot be deleted now")
                } else {
                  setShiftDate(data['currentMultiShiftJobDateToDisplay'])
                  warnDelete(data["jobUniqueId"], data["jobsClaimId"], data["currentMultiShiftJobDate"]);
                }
              },
            },
          ];
        }
        if (header.field === "ratings") {
          rowData[header.name] = {
            type: "ratings",
            value: data[header.field],
          };
        }
        if (header.name === "Approval") {
          rowData[header.name] = data[header.field].map((fld) => {
            const isSuccess = fld.isApproved;
            const iconClass = isSuccess
              ? "green-icon fa-check-circle"
              : "fa-times-circle red-icon";
            return {
              type: "icon",
              class: `fa icon-align ${iconClass}`,
            };
          });
        }
        if (header.field === "gpsTrackingStatus") {
          const gpsStatus = data["gpsCurrentTrackingStatus"];

          const showIcon = true; //gpsStatus !== 0 && gpsStatus !== 3;
          //const iconClass = (gpsStatus === 1 || gpsStatus === 0 || gpsStatus === 3) ? 'green-icon' : gpsStatus === 2 ? 'yellow-icon' : 'red-icon'
          const iconClass =
            gpsStatus === 0
              ? "grey-icon"
              : gpsStatus === 1 || gpsStatus === 3
                ? "green-icon"
                : gpsStatus === 2
                  ? "yellow-icon"
                  : "red-icon";

          if (showIcon) {
            rowData[header.name] = {
              type: "icon",
              class: `icon-align fa fa-map-marker ${iconClass}`,
              onClick: () => {
                showHideGps(data);
              },
            };
          }
        }
      }
    });
    return rowData;
  };

  const headers = [
    {
      name: '#',
      field: 'serialNo',
      type: 'text',
      headerTooltip: 'Line Item Number',
      width: 40,
      minWidth: 20,
      hide: false

    },
    {
      name: "Claim",
      field: "isClaimed",
      type: "icon",
      headerTooltip: 'Claimed',
      width: 50,
      minWidth: 40,
      maxWidth: 150,
      hide: false,
      icon: 'icon-align fa fa-anchor green-color-icon'
      // Claimed
    },
    {
      name: 'Unclaim',
      field: 'isUnClaimed',
      type: 'multi',
      headerTooltip: 'UnClaim',
      width: 35,
      minWidth: 40,
      maxWidth: 150,
      hide: false,
      icon: ' icon-align fa fa-remove orange-icon'
      // Claimed
    },
    {
      name: "GPS",
      field: "gpsTrackingStatus",
      type: "icon",
      filter: false,
      width: 35,
      minWidth: 35,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'GPS',
      icon: 'icon-align fa fa-map-marker green-icon'
    },
    {
      name: "Checkin",
      field: "isCheckedIn",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Checked In",
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-in green-icon'
    },
    {
      name: 'Break Time',
      field: 'breakTimeFlash',
      type: 'icon',
      filter: false,
      width: 35,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'Break Time',
      icon: 'icon-align fa fa-pause-circle-o green-icon'
    },
    {
      name: "Checkout",
      field: "isCheckedOut",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Checked out",
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-out fa-flip-horizontal green-icon'
    },
    {
      name: "Location",
      field: "locationName",
      type: "text",
      sort: false,
      width: 80,
      minWidth: 140,
      hide: false,
    },
    {
      name: "Shift title",
      field: "jobTitle",
      type: "text",
      sort: false,
      width: 100,
      minWidth: 210,
      hide: false,
    },

    {
      name: "Shift Date",
      field: "currentMultiShiftJobDateToDisplay",
      type: "text",
      sort: false,
      minWidth: 160,
      width: 160,
      hide: false,
    },
    {
      name: "Start",
      field: "shiftStartTime",
      type: "text",
      sort: false,
      headerTooltip: "Start Time",
      width: 70,
      minWidth: 60,
      hide: false,
    },
    {
      name: "End",
      field: "shiftEndTime",
      type: "text",
      sort: false,
      width: 70,
      minWidth: 60,
      headerTooltip: 'End Time',
      hide: false,
    },
    {
      name: "EX/IN",
      field: "inExAuthorizedStatus",
      type: "text",
      filter: false,
      sort: false,
      width: 50,
      minWidth: 30,
      maxWidth: 150,
      hide: false,
    },
    {
      name: "Name",
      field: "name",
      type: "text",
      filter: false,
      sort: false,
      width: 70,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Mentor',
      field: 'isMentor',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Mentor',
      maxWidth: 35,
      width:35,
      hide: false,
    },
    {
      name: "Favorite",
      field: "isFavorite",
      type: "text",
      filter: false,
      sort: false,
      headerTooltip: 'Favorite',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa fa-star green-icon'
    },
    {
      name: "Ratings",
      field: "ratings",
      type: "ratings",
      width: 75,
      minWidth: 85,
      hide: false,
    },
    {
      name: "Approval",
      field: "jobApproversList",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Approval",
      minWidth: 90,
      hide: false,
    },
    {
      name: 'Paid',
      field: 'isPaid',
      type: 'icon',
      filter: false,
      sort: false,
      width: 45,
      minWidth: 45,
      maxWidth: 150,
      hide: false,
    },
    {
      name: "Action",
      field: "action",
      type: "icon",
      filter: false,
      width: 85,
      minWidth: 110,
      hide: false,
    },
  ];

  const createPageData = (page, pageSize, totalCount) => {
    if (page === 1) {
      return {
        from: page,
        to: pageSize,
        total: totalCount,
        totalPages: Math.ceil(totalCount / pageSize),
        currentPage: page,
        pageSize: pageSize,
      };
    } else {
      const pageData = paginationCalculator({
        total: totalCount,
        current: page,
        pageSize: pageSize,
      });
      return {
        from: pageData.showingStart,
        to: pageData.showingEnd,
        total: totalCount,
        totalPages: Math.ceil(totalCount / pageSize),
        currentPage: page,
        pageSize: pageSize,
      };
    }
  };

  const formatTableData = (data) => {
    const tableData = {
      headers,
      rows: data?.multiJobShiftsOccurence?.map((data) => ({
        columns: generateRowData(data, headers),
      })),
      options: {
        sortable: false,
        filter: false,
        pagination: false,
        pageSize: pageSize || 10,
        height: "100%",
        layout: "autoHeight",
        resizable: true,
        showToggle: true,
        refreshFlag: true,
        gridloader,
        loader: true,
      },
      pageData: createPageData(page, pageSize, data?.totalCount),
      totalCount: data?.totalCount,
      currentPage: page,
      pageSize,
      firstPage: gotoFirstPage,
      nextPage: gotoNextPage,
      previousPage: gotoPreviousPage,
      lastPage: gotoLastPage,
      updatePageSize: updatePageSize,
      gotoPage: gotoSelectedPage,
      headerComponentParams: {
        sort: (order, column) => {
          dispatch(updateSort(order, column)).then(() => {
            dispatch(
              loadMultiShiftJobInfo({
                url: config.baseUrl,
                sortOrder: "string",
                sortColumn: "string",
                jobsShiftUniqueId
              })
            );
          });
        },
        headers,
      },
    };
    return tableData;
  };
  const viewJobinSamePage = (jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId,shiftType, save, occurrenceCorrectionType) => {
    dispatch(updateRequest({ jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save,viewJobTitle,shiftType, occurrenceCorrectionType })).then(() => {
      setShowViewJob(!showViewJob)
    });
  };

  const closeViewJob = () => {
    setShowViewJob(!showViewJob);
    if (updatedShiftTime) {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    }
    dispatch(resetModifyOccurrence())
    dispatch(refreshMultishiftInfo(false))
  };

  const saveViewJob = () => {
    if( (+payRateType === payRateTypeObj?.manualCal) && !payRateTotalShiftAmount){
      dispatch(setIsErrorPaymentRate(true))
      return
    }
    const params = {
      "jobShiftUniqueId": jobsShiftUniqueId,
      "shiftDateTime": requestData?.shiftDate,
      "singleShiftEndDate":shift?.endDate,
      "shiftStartTime": shift?.startTime?.name,
      "shiftEndTime": shift?.endTime?.name,
      "incentive": jobInfo?.incentive?.toString(),
      "jobsClaimId": requestData?.claimId,
      candidateDepartmentId: jobsShiftsDepartmentsList?.length  ? jobsShiftsDepartmentsList?.at(0)?.id : [],
      DepartmentName: jobsShiftsDepartmentsList?.length ? jobsShiftsDepartmentsList?.at(0)?.name : [],
      payRateType:payRateType ?? null,
      manualTotalShiftAmount:(+payRateType === payRateTypeObj?.manualCal)? payRateTotalShiftAmount : null,
      manualAmountPerShift:null
    }
    dispatch(editSaveTimeOccurrence(`${config.baseUrl}/Employers/savejobsunclaimedoccurance`, params)).then(() => {
      setShowViewJob(!showViewJob);
    }).then(() => dispatch(resetModifyOccurrence()))
  }

  const viewJob = (jobId, acceptableTravelDistance, shiftDate, claimId) => {
    dispatch(updateJobId(jobId, "/openshifts")).then(() => {
      navigate("/jobsummary", {
        state: {
          jobUniqueId: jobId,
          jobDate: shiftDate,
          jobsClaimId: claimId,
          gotoMatching: true,
          save: false,
          acceptableTravelDistance: acceptableTravelDistance,
        },
      });
    });
  };
  const GoBackToPage = () => {
    dispatch(firstPage());
    navigate(-1);
  };
  // const viewJobMessages = (jobId, isClaimed, candidateId) => {
  //   // if (!isClaimed) {
  //   //     setShowMessageModal (!showMessageModal)
  //   // } else {

  //   navigate("/jobmessages", {
  //     state: {
  //       jobUniqueId: jobId,
  //       candidateUniqueId: candidateId,
  //     },
  //   });
  //   // }
  // };
  const clickJobMessages = (jobId, candidateId) => {

    if (!candidateId) {
      setShowMessageModal(!showMessageModal);
    } else {
      navigate("/jobmessages", {
        state: {
          jobUniqueId: jobId,
          candidateUniqueId: candidateId,
        },
      });
    }
  };

  // const editJob = (jobId, isClaimed, acceptableTravelDistance) => {

  //   if (isClaimed) {
  //     setShowJobMessageModal(!showJobMessageModal);
  //   } else {
  //     dispatch(resetJobOpportunityInfo()).then(() => {
  //       dispatch(editPost()).then(() => {
  //         dispatch(setJobId(jobId)).then(() => {
  //           navigate("/jobopportunity", {
  //             state: {
  //               acceptableTravelDistance: acceptableTravelDistance,
  //             },
  //           });
  //         });
  //       });
  //     });
  //   }
  // };

  const cancelJobView = () => {
    dispatch(updateJobId(undefined)).then(() => {
      navigate("/shiftscoverage");
    });
  };

  const showHideGps = (jobData) => {
    if (jobData && jobData.jobUniqueId) {
      setOpenGps({
        show: true,
        jobData: jobData,
      });
    } else {
      setOpenGps({
        show: false,
        jobData: undefined,
      });
    }
  };
  const handleClose = () => setShow(false);
  const handleClosefalse = () => {
    setdeletedata({
      show: false,
    });
  };
  const handleCloseUnclaim = () => setShow(false);
  const handleClosefalseUnclaim = () => {
    setUnclaimData(false);
    setErrorsModalFormData({
      commentsError: '',
      reasonError: "",
    });
    setModalFormData({
      reason: "",
      comments: ""
    })
  };
  const handleDeleteData = () => {
    const params = {
      JobUniqueId: deleteId,
      AppUserId: AppuseridValue,
    };
    dispatch(
      deleteJob({ url: `${config.baseUrl}/Jobs/delete-job-details`, params })
    ).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    });
    setdeletedata({
      show: false,
    });
  };
  const unclaim = () => {
    singleUnclaimOccurrence(UnclaimId)
  }
  const singleUnclaimOccurrence = (UnclaimId) => {
    // Unclaim Reasons Error Handling
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      jobsClaimId: UnclaimId,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    }
    dispatch(
      UnclaimedbyEmployerApi({
        url: `${config.baseUrl}/Employers/unclaimOccurrence`,
        params
      })
    ).then(() => {
      setUnclaimData(false)
      setUnclaimId("")
      setErrorsModalFormData({
        reasonError: "",
        commentsError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      })
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    }
    )
  };
  const UnclaimedbyEmployer = () => {
    // Unclaim Reasons Error Handling
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      ...UnclaimId,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    }
    dispatch(
      UnclaimedbyEmployerApi({
        url: `${config.baseUrl}/Candidates/unclaimoccurrancebyemployer`,
        params
      })
    ).then(() => {
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    }
    ).then(() => {
      setErrorsModalFormData({
        commentsError: '',
        reasonError: "",
      });
      setModalFormData({ reason: "", comments: "" })
      setUnclaimData({ show: false, })
    })
  };

  // const showDeletedata = (jobId) => {
  //   setDeleteId(jobId);
  //   if (jobId) {
  //     setdeletedata({
  //       show: true,
  //       jobId: jobId,
  //     });
  //   } else {
  //     setdeletedata({
  //       show: false,
  //       jobId: undefined,
  //     });
  //   }
  // };
//   useEffect(() => {
//     const handler = (e) => {
//       if(pageName){
//         navigate(`/${pageName}`);
//       }
//     }
//     window.addEventListener("popstate", e => handler(e));
//     return () => {
//         window.removeEventListener("popstate", e => handler(e));
//     }
// }, [])
  const showUnclaimdata = (unClaimedId) => {
    if (unClaimedId) {
      setUnclaimData(true)
      setUnclaimId(unClaimedId)
    }
  };
  const hideModal = () => {
    setShowModal(!showModal);
  };

  const hideMessageModal = () => {
    setShowMessageModal(!showMessageModal);
  };

  const hideJobMessageModal = () => {
    setShowJobMessageModal(!showJobMessageModal);
  };

  const warnDelete = (jobUniqueId, jobClaimId, currentMultiShiftJobDate) => {
    setmulJobdetail({ JobUniqueId: jobUniqueId, jobClaimId: jobClaimId, occurranceDate: currentMultiShiftJobDate });
    setDeleteModal();
  }

  const setDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
    setDeleteModalFormData({
      reason: "",
      comments: "",
    });
    setDeleteErrorsModalFormData({
      reasonError: "",
      commentsError: "",
    });
  }

  const deleteMultishift = () => {
    // Error Handling for single shift delete Reasons in Dropdown
    if (!DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(DeleteModalFormData.reason) === 0) {
        if (!DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            ...DeleteErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      ...mulJobdetail,
      jobShiftsUniqueId: jobsShiftUniqueId,
      deleteReasonId: DeleteModalFormData.reason,
      otherDeleteReason: DeleteModalFormData.comments,
    }
    dispatch(DeleteMultiShiftJobOccurence(config.baseUrl, params)).then(() => {
      setDeleteModal();
      dispatch(
        loadMultiShiftJobInfo({
          url: config.baseUrl,
          sortOrder: "string",
          sortColumn: "string",
          jobsShiftUniqueId
        })
      );
    }).then(() => {
      setDeleteModalFormData({
        reason: "",
        comments: "",
      });
    })
  }
  const deleteAllOccurrence = () => {
    setShowMultiDelete(true)
  }
  const deleteMultishiftOccurrence = () => {
    dispatch(deleteAllMultishiftOccurrence(config.baseUrl, jobsShiftUniqueId)).then((response) => {
      setShowMultiDelete(false);
      setTimeout(() => {
        if (parseInt(response?.result) === 1) {
          navigate("/openshifts")
        }
      }, 1000)
    });

  };
  const setMultiDelete = () => {
    setShowMultiDelete(false)
  }
  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}

      <Header />
      <Sidebar />

      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title ms-2">Multi shift info</h1>
                <BackFixedButton
                  btnStyle={`btn-danger`}
                  btnName={'Back'}
                // backPage={backpage}
                backPage={pageName ? `/${pageName}`:""}
                />
              </div>

              {showViewJob && (
                <ModalGoTo
                  showHide={closeViewJob}
                  save={saveViewJob}
                // backPath={backPath}
                // label={"Job Summary"}
                // relativeToParent = {true}
                >
                  <ViewJob pageName={pageName} />
                </ModalGoTo>
              )}
              {showMessageModal && (
                <Modal
                  showHide={hideMessageModal}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={true}
                >
                  <span className="fw-bold">
                    There are no Claimed Candidates for this Shift !
                  </span>
                </Modal>
              )}
              {
                showDeleteModal && <Modal
                  showHide={setDeleteModal}
                  saveFunction={deleteMultishift}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={'Delete'}
                >
                  <span className="fw-bold">
                    Are you sure want to delete this shift occurrence "{shiftDate}"?
                  </span>
                  <div>
                    {/* Delete Reasons Dropdown */}
                    <div className="mt-5">
                      <label for="reason" className="mx-2">
                        Choose a Reason :
                      </label>
                      <select
                        name="reason"
                        id="reason"
                        className="form-select form-control"
                        required
                        onChange={DeleteConfirmationModalBoxHandleChange}
                      >
                        <option selected disabled>
                          Choose any one
                        </option>
                        {deleteEmployerReasons.map((reasonLists, index) => {
                          return (
                            <option key={index} value={reasonLists.id}>
                              {reasonLists.name}
                            </option>
                          );
                        })}
                      </select>
                      {
                        <span className="text-danger mx-2">
                          {DeleteErrorsModalFormData?.reasonError}
                        </span>
                      }
                      {parseInt(DeleteModalFormData.reason) === 0 ? (
                        <div className="mt-2">
                          <textarea
                            className="form-control"
                            name="comments"
                            value={DeleteModalFormData.comments}
                            onChange={DeleteConfirmationModalBoxHandleChange}
                          ></textarea>
                          {
                            <span className="text-danger mx-2">
                              {DeleteErrorsModalFormData?.commentsError}
                            </span>
                          }
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Modal>
              }
              {
                showMultiDelete && <Modal
                  showHide={setMultiDelete}
                  saveFunction={deleteMultishiftOccurrence}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={'Delete'}
                >
                  <span className="fw-bold">
                    Are you sure want to delete whole multishift?
                  </span>
                </Modal>
              }
              {openGps.show && (
                <Modal label={"GPS"} onlyClose={true} showHide={showHideGps}>
                  <GPSInfo {...openGps.jobData} show={openGps.show} />
                </Modal>
              )}
              {Unclaimdata === true ?
                (
                  <Unclaimedmodalpopup
                    showUnclaim={true}
                    handleUnclaimClose={handleClosefalseUnclaim}
                    handleUnclaim={unclaim}
                    children={<div className="mt-5 ">
                      {/* UnClaim Reasons Dropdown */}
                      <div>
                        <label for="reason" className="mx-2">
                          Choose a Reason :
                        </label>
                        <select
                          name="reason"
                          id="reason"
                          className="form-select form-control"
                          required
                          onChange={ConfirmationModalBoxHandleChange}
                        >
                          <option selected disabled>
                            Choose any one
                          </option>
                          {unClaimEmployerReasons.map((reasonLists, index) => {
                            return (
                              <option key={index} value={reasonLists.id}>
                                {reasonLists.name}
                              </option>
                            );
                          })}
                        </select>
                        {
                          <span className="text-danger mx-2">
                            {ErrorsModalFormData?.reasonError}
                          </span>
                        }
                        {parseInt(ModalFormData.reason) === 0 ? (
                          <div className="mt-2">
                            <textarea
                              className="form-control"
                              name="comments"
                              value={ModalFormData.comments}
                              onChange={ConfirmationModalBoxHandleChange}
                            ></textarea>
                            {
                              <span className="text-danger mx-2">
                                {ErrorsModalFormData?.commentsError}
                              </span>
                            }
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>}
                  />
                ) : ""}
              <div className="card ">
                <div className="card-body position-relative">
                  {/* <div
                    onClick={() =>
                      clickJobMessages(multiShiftId, candidateUniqueId)
                    }
                    className=" position-absolute adjust-chat text-primary fs-4"
                  >
                    <i className="icon-align fa fa-commenting h-100 w-100"></i>
                  </div> */}
                  {/* <div
                    onClick={() =>deleteAllOccurrence()}
                    className=" position-absolute adjust-delete text-primary fs-4"
                  >
                    <i className="icon-align zmdi zmdi-delete h-100 w-100"></i>
                  </div> */}
                  <div class="row row-cols-1">
                    <div className="col-8">
                      {/* <label
                        className="fw-semibold col-3"
                        htmlFor={data?.jobInfo?.location}
                      >
                        Location Name :
                      </label>
                      <span className="col-9">{data?.jobInfo?.location}</span> */}
                    </div>
                    <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={data?.jobInfo?.startDate}
                      >
                        Start Date :
                      </label>
                      <span className="col-9"> {data?.jobInfo?.startDate}</span>
                    </div>
                    <div className="col-8">
                      <label
                        className="fw-semibold col-3"
                        htmlFor={data?.jobInfo?.endDate}
                      >
                        End Date :
                      </label>
                      <span className="col-9"> {data?.jobInfo?.endDate}</span>
                    </div>
                    <div className="col-12">
                      <label
                        className="fw-semibold col-2"
                        htmlFor={convertToString(
                          data?.jobInfo?.recurrenceRule
                        )}
                      >
                        Occurance :
                      </label>
                      <span className="col-10 text-start">
                        {" "}
                        {convertToString(
                          data?.jobInfo?.recurrenceRule
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="inline-block d-flex justify-content-between">
                      <BackFixedButton
                        btnStyle={`btn-danger`}
                        btnName={"Back to Openshift Page"}
                        backPage="/openshifts"
                      />
                      <div className="mx-2">
                        <select
                          className="form-select"
                          onChange={(e) => setMultiShiftFilterDataUpdateId(e.target.value)}
value={multiShiftFilterUpdateId}
                        >
                          {
                            finalMultiShiftFilterData?.map((option) => (
                              <option value={option.id}>{option.name}</option>
                            ))
                          }
                        </select>
                      </div>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <DataGrid {...formatTableData(data)} refresh={refresh} pageName={'multiShift'} />
                    </div>
                  </div>


                </div>

              </div>
              <div class="pull-right mb-3">
                <BackFixedButton
                  btnStyle={`btn-danger`}
                  btnName={'Back'}
                // backPage={backpage}
                backPage={pageName ? `/${pageName}`:""}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiShiftJobInfo;
